import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a530aee2cc25000144ec475_1786845717947_2c2ae16a/ledgerpay/src/app/terms/page.tsx");
